// extracted by mini-css-extract-plugin
export default {"Text":"DeleteFolderModal_Text__nyTAd","Title":"DeleteFolderModal_Title__Fj3GJ","Icon":"DeleteFolderModal_Icon__N4HGW","Buttons":"DeleteFolderModal_Buttons__7p517"};